import { forwardRef, useRef, useState } from "react";
import styles from "./GoogleAddressInput.module.scss";
import Autocomplete from "react-google-autocomplete";
import Input from "./Input";
import States from "../constant/states";
import Select from "./Select";

const GoogleAddressInput = forwardRef(function GoogleAddressInput(props, ref) {
  const { label, mandatory, errors, clearError, setError, ...otherProps } =
    props;

  const myGoogleApiKey = "AIzaSyC5K5DOT15-NBDl2JuCNZGzXafuH4rMviA";

  const addressLineRef = useRef();
  const suburbRef = useRef();
  const stateRef = useRef();
  const postcodeRef = useRef();

  // function clearErrorHandler(){
  //   clearError();
  // }

  // function setErrorHandler(){
  //   setError();
  // }
  function handlePlaceSelected(place) {
    if (place === undefined) return;

    //find the unitno if exists
    var unitParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "subpremise") > -1
    );
    var streetNoParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "street_number") > -1
    );
    var streetNameParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "route") > -1
    );
    var suburbParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "locality") > -1
    );
    var stateParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "administrative_area_level_1") > -1
    );
    var postcodeParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "postal_code") > -1
    );

    let addressLine = `${streetNoParts[0].short_name} ${streetNameParts[0].short_name}`;

    if (unitParts.length > 0) {
      addressLine = unitParts[0].short_name + " " + addressLine;
    }

    addressLineRef.current.value = addressLine;

    suburbRef.current.value =
      suburbParts.length > 0 ? suburbParts[0].short_name : "";
    stateRef.current.value =
      stateParts.length > 0 ? stateParts[0].short_name : "";
    postcodeRef.current.value =
      postcodeParts.length > 0 ? postcodeParts[0].short_name : "";

    if (addressLineRef.current.value) clearError("AddressLine1");
    if (suburbRef.current.value) clearError("Suburb");
    if (stateRef.current.value) clearError("State");
    if (postcodeRef.current.value) clearError("Postcode");
  }
  return (
    <>
      <div className={styles.formGroup}>
        <label>
          {label}
          {mandatory && <label className={styles.mandatory}>*</label>}
          <Autocomplete
            name="addressLine1"
            id="addressLine1"
            ref={addressLineRef}
            apiKey={myGoogleApiKey}
            onPlaceSelected={(place) => {
              handlePlaceSelected(place);
            }}
            options={{
              types: ["address"],
              componentRestrictions: { country: "au" },
            }}
          />
        </label>
        <div className="error">
          {errors["addressLine1"] ? "Street address is required" : ""}
        </div>
      </div>

      <Input
        name="suburb"
        id="suburb"
        type="text"
        label="Suburb"
        mandatory={true}
        ref={suburbRef}
        clearError={clearError}
        setError={setError}
        error={errors["suburb"] ? "Suburb is required" : ""}
      />
      <div className={styles.stateWrapper}>
        <Select
          name="state"
          id="state"
          label="State"
          ref={stateRef}
          mandatory={true}
          simpleValues={States}
          clearError={clearError}
          setError={setError}
          error={errors["state"] ? "State is required" : ""}
        ></Select>
        <Input
          name="postcode"
          id="postcode"
          type="text"
          label="Postcode"
          ref={postcodeRef}
          mandatory={true}
          clearError={clearError}
          setError={setError}
          error={errors["postcode"] ? "Postcode is required" : ""}
        />
      </div>
    </>
  );
});

export default GoogleAddressInput;
